import React from 'react';

import moment from 'moment';
import numeral from 'numeral';

import TotalOrders from '../../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/TotalOrders';
import RevIcon from '../../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/Revenue';
import AvgSpendIcon from '../../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/AvgSpend';
import TotalTipsIcon from '../../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/TotalTips';
import AvgTipsIcon from '../../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/AvgTips';
import UniqueIcon from '../../yoello-lib/modules/components/Analytics/TotalsListWidget/TotalsListItem/Icons/UniqueCustomers';

import Styles from './styles.module.scss';

export const generateTitle = (t: (key: string) => string, mainTitle: string, start: number | Date, end: number | Date) => {
    const mStart = moment(start);
    const mEnd = moment(end);
    const mToday = moment(new Date());
    //Only show year if either start or end year is not this year
    const format = mEnd.year() === mStart.year() && mStart.year() === mToday.year() ? "D MMM" : "D MMM YYYY";
    if (mStart.date() === mEnd.date()) {
        if (mStart.date() === mToday.date()) {
            return <div className={Styles.Title}><span className={Styles.TitleDate}>{t('dashboard.todays')} </span><span>{mainTitle}</span></div>;
        }
        return <div className={Styles.Title}><span>{mainTitle} </span><span className={Styles.TitleDate}>{mStart.format(format)}</span></div>;
    }
    return <div className={Styles.Title}><span>{mainTitle} </span><span className={Styles.TitleDate}>{`${mStart.format(format)} to ${mEnd.format(format)}`}</span></div>;
}

export const formatTotal = (value: number, formatCurrency: Function) => {
    return formatCurrency(value);
}

export const formatTopFive = (topFiveList: any[], formatCurrency: Function) => {
    return topFiveList.sort((a, b) => b.total_ordered - a.total_ordered).map((obj: any) => {
        return {
            id: obj.menu_item_id,
            name: obj.name_public,
            category: obj.category_name,
            total: formatValue(obj.total_ordered),
            revenue: formatCurrency(obj.total_revenue),
            photoUrl: obj.url_photo
        } as ITopFive;
    });
}

const formatValue = (value: number) => {
    const nValue = numeral(value);
    let format = value > 999999 ? '0,0a' : '0,0';
    return nValue.format(format);
}

export const formatTotalsList = (totalsList: any, formatCurrency: Function) => {
    return [
        { id: "order", label: 'analytics.totals.order', icon: <TotalOrders />, value: formatValue(totalsList.count_of_orders?.value) },
        { id: "revenue", label: 'analytics.totals.revenue', icon: <RevIcon />, value: formatCurrency(totalsList.total_revenue?.value) },
        { id: "avg_spend", label: 'analytics.totals.avg_spend', icon: <AvgSpendIcon />, value: formatCurrency(totalsList.avg_order_spend?.value) },
        { id: "avg_tips", label: 'analytics.totals.avg_tips', icon: <AvgTipsIcon />, value: formatCurrency(totalsList.avg_gratuity?.value) },
        { id: "total_tips", label: 'analytics.totals.total_tips', icon: <TotalTipsIcon />, value: formatCurrency(totalsList.total_gratuity?.value) },
        { id: "unique_custs", label: 'analytics.totals.unique_custs', icon: <UniqueIcon />, value: formatValue(totalsList.total_unique_customers?.value) },
    ]
}

export const formatRushData = (data: any[]) => {
    return data.map((item: { date: string, avg: number }) => {
        const hour = parseInt(item.date.split(':')[0]);
        return [Date.UTC(1970, 1, 1, hour, 0, 0), item.avg];
    })
}